import {
  TOGGLE_SELECTED_PERMISSION,
  INIT_PERMISSIONS_SELECTION,
  TOGGLE_SELECTED_PERMISSIONS
} from './action-types';


export function rolesReducer(state = {}, { payload, type }) {
  /* eslint-disable no-case-declarations */
  switch (type) {
    case TOGGLE_SELECTED_PERMISSION:
      return Object.assign({}, state, updatePermissions(state, payload.mid, [{ id: payload.pid }]));
    case TOGGLE_SELECTED_PERMISSIONS:
      return Object.assign({}, state, updatePermissions(state, null, payload.permissions));
    case INIT_PERMISSIONS_SELECTION:
      return Object.assign({}, state, {
        selectedPermissions: {},
        assignedCounts: {}
      });
    default:
      return state;
  }
  /* eslint-enable no-case-declarations */
}


/**
 * Helper para actualizar los permisos asignados/desasignados en el state.
 * 
 * @param {object} state
 * @param {number} mid
 * @param {object[]} permissions
 */
function updatePermissions(state, mid, permissions) {
  // actualizamos el permiso
  let { selectedPermissions, assignedCounts } = Object.assign({}, state);
  permissions.forEach((permiso) => {
    selectedPermissions[permiso.id] = !selectedPermissions[permiso.id];
    const moduloId = mid || permiso.modulo.id;
    // actualizamos el contador de permisos por modulo
    assignedCounts[moduloId] = assignedCounts[moduloId] || 0;

    if (selectedPermissions[permiso.id]) {
      assignedCounts[moduloId] += 1;
    } else {
      assignedCounts[moduloId] -= 1;
    }
  });
  return { selectedPermissions, assignedCounts };
}


// WEBPACK FOOTER //
// ./src/core/services/roles/reducer.js